// Champion skins row: the track scrolls natively with snap; the buttons page by the visible width and wrap around
// at the ends like a carousel, and hide when all skins fit
export function initSkinsSliders() {
    document.querySelectorAll('.skins-slider').forEach(function (slider) {
        const track = slider.querySelector('.skins-slider__track');
        const navs = slider.querySelectorAll('.skins-slider__nav');

        slider.addEventListener('click', function (e) {
            const button = e.target.closest('.skins-slider__nav');
            if (!button) return;

            const dir = Number(button.dataset.dir);
            const end = track.scrollWidth - track.clientWidth;
            // A pixel of slack: scrollLeft is fractional on zoomed pages
            if (dir > 0 && track.scrollLeft >= end - 1) {
                track.scrollTo({left: 0});
            } else if (dir < 0 && track.scrollLeft <= 1) {
                track.scrollTo({left: end});
            } else {
                track.scrollBy({left: dir * track.clientWidth});
            }
        });

        new ResizeObserver(function () {
            const fits = track.scrollWidth <= track.clientWidth;
            navs.forEach((nav) => nav.classList.toggle('hidden', fits));
        }).observe(track);
    });
}
